module.exports = __webpack_public_path__ + "fonts/Inter-100-latin-ext6.1ad231a.woff2";